import moment from "moment";
import React from "react";
import PropTypes from "prop-types";
import submit from "submit-form";

export const CommentCard = (
  { comment: { phaseDescription, dateAttachment } },
  { locals }
) => {
  const { athlete } = locals;

  const openPhaseDescriptionModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "phase-description",
        dateAttachment: moment(dateAttachment, "YYYYMMDD").format(
          "MMM D, YYYY"
        ),
        phaseDescription,
        phaseDescriptionStatus: "edit",
      },
    });
  };

  const openRemovePhaseDescriptionModal = () => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        "modal[type]": "remove-phase-description",
        phaseDescription,
        dateAttachment: moment(dateAttachment, "YYYYMMDD").format(
          "MMM D, YYYY"
        ),
        athleteId: athlete._id,
      },
    });
  };

  return (
    <div role="footer-card" className="comments">
      <div role="card-header">
        <div className="header-date">
          {moment(dateAttachment, "YYYYMMDD").format("MMM D, YYYY")}
        </div>
        <div className="header-actions">
          <div
            className="comment-icon-button edit"
            onClick={openPhaseDescriptionModal}
          >
            <img src="/img/new-icons/edit-pencil.svg" />
          </div>
          <div
            className="comment-icon-button"
            onClick={openRemovePhaseDescriptionModal}
          >
            <img src="/img/new-icons/red-trash.svg" />
          </div>
        </div>
      </div>

      <div className="comment-description">{phaseDescription}</div>
    </div>
  );
};

CommentCard.contextTypes = { locals: PropTypes.object };
